// extracted by mini-css-extract-plugin
export default {"figures-summary":"figures-summary--h6jJ1","figuresSummary":"figures-summary--h6jJ1"};